export default (cn: number) => {
  const scn = cn.toString();
  return (
    scn.length === 3 &&
    (scn[1] === '0' || scn[1] === '1') &&
    (scn[2] === '0' || scn[2] === '1' || scn[2] === '2')
  );
};
